import React, { useContext, useState } from 'react';

const DirectDepositFlowTitleContext = React.createContext('');

const DirectDepositFlowTitleDispatchContext = React.createContext<(title: string) => void>(() => {
  // no-op
});

export const DirectDepositFlowTitleProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [title, setTitle] = useState('');

  return (
    <DirectDepositFlowTitleContext.Provider value={title}>
      <DirectDepositFlowTitleDispatchContext.Provider value={setTitle}>
        {children}
      </DirectDepositFlowTitleDispatchContext.Provider>
    </DirectDepositFlowTitleContext.Provider>
  );
};

export function useTitleState() {
  return useContext(DirectDepositFlowTitleContext);
}

export function useTitleDispatch() {
  return useContext(DirectDepositFlowTitleDispatchContext);
}
